import { fetchVideos } from '@gn-audio/core/api/knowledge-base';
import { chunk } from '../utils/chunk';
import { videoEvaluator } from '../utils/video-evaluator';
var VideoSectionSpotController = (function () {
    function VideoSectionSpotController($scope, $q, productContextService) {
        this.$scope = $scope;
        this.$q = $q;
        this.productContextService = productContextService;
    }
    VideoSectionSpotController.prototype.$onInit = function () {
        this.$scope.videos = [];
        this.$scope.videoRows = [];
        this.productContextService.subscribe().then(null, null, this.groupSelectedHandler.bind(this));
    };
    VideoSectionSpotController.prototype.groupSelectedHandler = function (group) {
        var _this = this;
        if (!group) {
            return;
        }
        this.$scope.group = group;
        this.$scope.promise = this.$q.when(fetchVideos(group.groupId))
            .then(function (videos) {
            _this.$scope.videos = (videos || []).filter(videoEvaluator);
            _this.$scope.videoRows = chunk(_this.$scope.videos, 2);
            return _this.$scope.videos;
        });
    };
    VideoSectionSpotController.$inject = ['$scope', '$q', 'productContextService'];
    return VideoSectionSpotController;
}());
export { VideoSectionSpotController };
